// extracted by mini-css-extract-plugin
module.exports = {"header":"view_header__3PxJ-","closeBtn":"view_closeBtn__3tZVt","ownerCont":"view_ownerCont__1eDCu","title":"view_title__1QkoX"};